import { Fragment, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import MenuItem from "@mui/material/MenuItem";

import MySelectField from "components/Inputs/MySelectField";

const VehicleTypeSelect = (props) => {
  const { t } = useTranslation();
  const { enums, value, updateValues } = props;
  const [vehicleTypes, setVehicleTypes] = useState();

  useEffect(() => {
    if (enums) {
      setVehicleTypes(enums?.data?.vehicles?.car?.type);
    }
  }, [enums]);

  const handleSelectChange = ({ target }) => {
    updateValues({ [target.name]: target.value });
  };

  return (
    <Fragment>
      {vehicleTypes ? (
        <MySelectField
          id="select_order_type"
          name="type"
          value={value ? value : 0}
          onChange={handleSelectChange}
        >
          {vehicleTypes.map((option) => (
            <MenuItem key={option.key} value={option.key}>
              {t(option.value)}
            </MenuItem>
          ))}
        </MySelectField>
      ) : null}
    </Fragment>
  );
};

export default VehicleTypeSelect;
